export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "sales_on": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ventes ce mois sur"])},
        "expected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["attendues."])},
        "projection_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Projection fin de mois :"])},
        "projection_value": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " ventes"])}
      },
      "en": {
        "sales_on": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sales this month out of"])},
        "expected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["expected."])},
        "projection_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End of month projection:"])},
        "projection_value": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " sales"])}
      }
    }
  })
}
